<template>
  <div class="enter-order-container">
    <SimonModal
      :is-visible="showESimCheckInfoModal"
      @hide="showESimCheckInfoModal = false"
      @close="showDeviceCheck = !showDeviceCheck"
      size="large"
      id="esim-check-info-modal"
      custom-modal-class="esim-check-info-modal"
      show-footer-buttons
      :btn-left-title="getSlotText('btnCancel', 'Abbrechen')"
      :btn-right-title="getSlotText('btnOk', 'Bestätigen')"
      @btnLeft="showESimCheckInfoModal =! showESimCheckInfoModal"
      @btnRight="enterOrderProcess"
    >
      <template v-slot:modalTitle>
        <h2><slot name="txtHeading">Lorem ipsum</slot></h2>
      </template>
      <div>
        <p><slot name="txtBefore">Lorem ipsum dolor sit amet, consectetur adipisici elit, sed eiusmod tempor incidunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquid ex ea commodi consequat</slot></p>
        <b-form
          :id="'form' + _uid"
          :novalidate="true"
          class="device-check-modal-form"
          ref="form">
              <ESimDevicecheck :available-device-types="availableDeviceTypes">
                <template v-for="slot in possibleChildSlotsFor('DeviceCheck')" v-slot:[`${slot.child}`]>
                  <slot :name="`${slot.parent}`"></slot>
                </template>
              </ESimDevicecheck>
        </b-form>
      </div>
    </SimonModal>
    <button class="filled yellow" :disabled="disableOrderBtn || disabled" @click="openESimCheckModal">
      <slot name="btn"></slot>
    </button>
  </div>
</template>

<script>

import customerContractState from '@/mixins/customerContractState'
import { BForm } from 'bootstrap-vue'
import ESimDevicecheck from '@/components/process/generic/SubstituteSimCard/ESimDevicecheck.vue'
import SimonModal from '@/components/modal/SimonModal.vue'

export default {
  name: 'OrderEsimBtn',
  components: { SimonModal, ESimDevicecheck, BForm },
  data () {
    return {
      showESimCheckInfoModal: false,
      showDeviceCheck: false
    }
  },
  props: {
    orderTargetUrl: {
      type: String,
      default: ''
    },
    simOrderStatus: {
      type: Object,
      default: () => {}
    },
    preOrder: {
      type: Function,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    availableDeviceTypes: {
      type: String,
      default: ''
    }
  },
  methods: {
    openESimCheckModal: function () {
      this.showESimCheckInfoModal = true
    },
    enterOrderProcess: function () {
      if (typeof this.preOrder === 'function') {
        this.preOrder()
      }
      if (this.isOrderPossible) {
        window.location.href = this.orderTargetUrl
        this.$store.commit('checkoutv2/substituteSim/setSkippedSelection', true)
        return
      }
      let msg
      if (this.isOrderToEarly) {
        msg = this.$slots.errorToEarly?.[0]?.text
      }
      if (this.simOrderStatus.statusInfo === 'BlockedByCustomerStatus') {
        msg = this.$slots.errorCustomerStatus?.[0]?.text || this.fallbackErrorMessage
      }
      if (this.simOrderStatus.statusInfo === 'BlockedByDunningLevel') {
        msg = this.$slots.errorDunningLevel?.[0]?.text || this.fallbackErrorMessage
      }
      if (msg === undefined || msg === null) {
        msg = this.fallbackErrorMessage
      }
      this.errorToast(msg)
    }
  },
  computed: {
    fallbackErrorMessage: function () {
      return this.$slots.errorGeneric?.[0]?.text || 'Ufff! Leider kannst du derzeitig keine Ersatz-SIM-Karte bestellen (Fehler: ES1). Bitte wende dich einmal an die Hotline.'
    },
    disableOrderBtn: function () {
      return (!this.loadedContractState || this.contractTerminated)
    },
    isOrderPossible: function () {
      return this.simOrderStatus.orderable
    },
    isOrderToEarly: function () {
      if (this.simOrderStatus.orderDate === null) {
        return false
      }
      return this.timeSinceLatestOrder <= 30
    },
    timeSinceLatestOrder: function () {
      const today = new Date()
      const orderDate = new Date(this.simOrderStatus.orderDate)
      const diff = today.getTime() - orderDate.getTime()
      return Math.floor(diff / (1000 * 60 * 60 * 24))
    }
  },
  mixins: [
    customerContractState()
  ]
}
</script>
